import AttendanceType from "./actionTypes"

// function that called as action
const getWorkClass = data => ({
  type: AttendanceType.GET_ATTENDANCE_WORK_CLASSIFICATION,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getWorkClassSuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_WORK_CLASSIFICATION_SUCCESS,
  payload: data,
})

// function that called as action
const getAttendanceToday = (data, action) => ({
  type: AttendanceType.GET_ATTENDANCE_WORK_TODAY,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const getAttendanceTodaySuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_WORK_TODAY_SUCCESS,
  payload: data,
})

// function that called as action
const getOtherWork = () => ({
  type: AttendanceType.GET_ATTENDANCE_OTHER_WORK_LIST,
})

// function to update state in reducer when fetching api is succeed or failed
const getOtherWorkSuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_OTHER_WORK_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getAllOrderList = () => ({
  type: AttendanceType.GET_ATTENDANCE_ALL_ORDER_LIST,
})

// function to update state in reducer when fetching api is succeed or failed
const getAllOrderListSuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_ALL_ORDER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getMonthHistory = (data, action) => ({
  type: AttendanceType.GET_ATTENDANCE_HISTORY,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const getMonthHistorySuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_HISTORY_SUCCESS,
  payload: data,
})

// function that called as action
const getAllHistoryDate = (data, action) => ({
  type: AttendanceType.GET_ATTENDANCE_HISTORY_BY_DATE,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const getAllHistoryDateSuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_HISTORY_BY_DATE_SUCCESS,
  payload: data,
})

// function that called as action
const getDetailHistoryDate = (data, action) => ({
  type: AttendanceType.GET_ATTENDANCE_DETAIL_HISTORY_DATE,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailHistoryDateSuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_DETAIL_HISTORY_DATE_SUCCESS,
  payload: data,
})

// function that called as action
const getAssignmentList = action => ({
  type: AttendanceType.GET_ATTENDANCE_ASSIGMENT_LIST,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const getAssignmentListSuccess = data => ({
  type: AttendanceType.GET_ATTENDANCE_ASSIGMENT_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const postClockIn = (data, action) => ({
  type: AttendanceType.POST_CLOCK_IN,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const postClockInSuccess = data => ({
  type: AttendanceType.POST_CLOCK_IN_SUCCESS,
  payload: data,
})

// function that called as action
const postClockOut = (data, action) => ({
  type: AttendanceType.POST_CLOCK_OUT,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const postClockOutSuccess = data => ({
  type: AttendanceType.POST_CLOCK_OUT_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: AttendanceType.PUT_ATTENDANCE_DATE,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: AttendanceType.PUT_ATTENDANCE_DATE_SUCCESS,
  payload: data,
})

// function that called as action
const deleteData = (data, action) => {
  return {
    type: AttendanceType.DELETE_ATTENDANCE,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const deleteDataSuccess = data => ({
  type: AttendanceType.DELETE_ATTENDANCE_SUCCESS,
  payload: data,
})

const AttendanceAction = {
  getWorkClass,
  getWorkClassSuccess,

  getAttendanceToday,
  getAttendanceTodaySuccess,

  getOtherWork,
  getOtherWorkSuccess,

  getAllOrderList,
  getAllOrderListSuccess,

  getMonthHistory,
  getMonthHistorySuccess,

  getAllHistoryDate,
  getAllHistoryDateSuccess,

  getDetailHistoryDate,
  getDetailHistoryDateSuccess,

  getAssignmentList,
  getAssignmentListSuccess,

  postClockIn,
  postClockInSuccess,

  postClockOut,
  postClockOutSuccess,

  putData,
  putDataSuccess,

  deleteData,
  deleteDataSuccess,
}

export default AttendanceAction
